import { serviceRequest } from 'utils/http';
import { SiteEmployeeService } from 'common/api';

export function getCurrentSiteEmployeeAPI() {
  return serviceRequest(() =>
    SiteEmployeeService.siteEmployeeControllerGetCurrentSiteEmployee()
  );
}
